// Componentes específicos de redes-atencion
const redesAtencionApp = new Vue({
  el: "#redes-atencion-app"
});

window.redesAtencionApp = redesAtencionApp;